import React from 'react'
import Fade from '../../Utils/Fade'
import {isEmpty} from 'lodash'

export default class Eligible extends React.PureComponent {
    render() {
        const {product, answers, processEnroll, translationData} = this.props
        let showDownload = true;

        if ('enbrel' === product.name) {
            var returnAnswer = answers.filter(function(answer) {
                return answer.name === 'Returning'
            })[0];

            if (returnAnswer) {
                showDownload = !returnAnswer.options.checkedYes;
            }
        }

        return (
            <div className="col-md-8 col-md-offset-2">
                {
                    !isEmpty(translationData) ?
                        <Fade duration={0.5}>
                            <div className="eligible-content">
                                <h1>{translationData.eligibleMsg.title}</h1>
                                <p>{translationData.eligibleMsg.content}</p>
                                
                                
                            </div>
                            <div className="eligible-btn">
                                <a  href='https://asnfapply.com/'
                                    target='_blank'
                                    className="btn btn-default semibold process-prev">
                                    {translationData.applyOnline}
                                    <img src="/assets/images/external_link_icon.svg" className="external" />
                                </a>
                                {showDownload && (<button
                                    className="btn btn-default semibold process-next"
                                    onClick={() => processEnroll(product.name)}>
                                    {translationData.downloadApplication}
                                </button>
                                )}
                            </div>
                            <div className="eligible-introduce">
                                <p>{translationData.eligibleMsg.comment}</p>
                            </div>
                        </Fade>
                        :
                        null
                }
            </div>
        )
    }
}